import { render, staticRenderFns } from "./WyfSymbolic.vue?vue&type=template&id=b63e94d2"
var script = {}
import style0 from "./WyfSymbolic.vue?vue&type=style&index=0&id=b63e94d2&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports